var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isVisible
    ? _c("div", { attrs: { "data-qa": "lpu_staff_admin" } }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", [
          _setup.showDeleteDoctorsForm
            ? _c(
                "form",
                {
                  staticClass: "d-inline-block",
                  attrs: { action: _setup.deleteDoctorsUrl, method: "post" },
                },
                [
                  _c("input", {
                    attrs: { type: "hidden", name: "csrfmiddlewaretoken" },
                    domProps: { value: _setup.context.csrf_token },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "hidden", name: "lpu" },
                    domProps: { value: _setup.context.lpu.id },
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("div", { attrs: { id: "dialog" } }),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [_c("aside", { attrs: { id: "widget_panel_container" } })])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("button", { staticClass: "adminka", attrs: { type: "submit" } }, [
      _vm._v("\n        Удалить всех врачей\n        "),
      _c("br"),
      _c("br"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "upload_container d-none" }, [
      _c("input", {
        staticClass: "lpu-staff-admin__upload-input",
        attrs: { id: "upload1", type: "file" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }